import { AdoverlayRange } from '@app/api/audit-api';
import { DateTimeStr, Timestamp, toDateTimeStr, toTimestamp } from '@mi-front/core';
import { Row } from '@tanstack/react-table';
import moment from 'moment';
import loadash from 'lodash';

export interface FormattedAdoverlayType {
  date: DateTimeStr;
  start_time: number;
  start_timestamp: Timestamp;
  duration: number;
  brand: string;
  image_b64: string;
  end_time: number;
  end_timestamp: Timestamp;
}

export interface FormattedAdoverlayMarkerType {
  date: DateTimeStr;
  ads: FormattedAdoverlayType[];
}

export const filterAdoverlay = (row: Row<any>, text: string, filterValue: string) => {
  const value = row.getValue(text);
  if (typeof value === 'string') {
    return value.toLowerCase().includes(filterValue.toLowerCase());
  }
  return false;
};

export const filterAdoverlayData = (data: AdoverlayRange[]) => {
  return data.filter((item) => {
    return (
      item.ad_overlay_groups.length > 0 &&
      item.ad_overlay_groups.every((group) => group.ads && group.ads.length > 0)
    );
  });
};

export const formatAdoverlayData = (data: AdoverlayRange[]): FormattedAdoverlayType[] => {
  return data.flatMap((item) => {
    const timestamp = parseInt(item.filename.split('__')[0]);
    const date = toDateTimeStr(timestamp);

    return item.ad_overlay_groups.flatMap((adGroup) => {
      return adGroup.ads.map((ad) => {
        return {
          date: toDateTimeStr(moment(date).add(ad.start_time, 'second')),
          brand: ad.brand,
          image_b64: ad.image_b64,
          start_time: ad.start_time,
          start_timestamp: toTimestamp(toDateTimeStr(moment(date).add(ad.start_time, 'second'))),
          end_time: ad.end_time,
          duration: adGroup.duration,
          end_timestamp: toTimestamp(toDateTimeStr(moment(date).add(ad.end_time, 'second'))),
        };
      });
    });
  });
};

export const formatAdoverlayForMarker = (
  adoverlays: FormattedAdoverlayType[],
): FormattedAdoverlayMarkerType[] => {
  const grouped = loadash.groupBy(adoverlays, (obj) => obj.date);
  return Object.entries(grouped).map(([date, ads]) => ({
    date: date as DateTimeStr,
    ads,
  }));
};
